
// export function highest(value){

//     var highestval = 0;
    
//     for(var i=0; i<value.length; i++){
//         if(parseInt(value[i].in) > highest){
//             highestval = parseInt(value[i].in)
//         }

//         console.log(parseInt(value[i]));
//         if(parseInt(value[i].out) > highest){
//             highestval = parseInt(value[i].out)
//         }
//     }

//     console.log(highestval);

//     return highestval;

// }


export function highest(data){


    var high = (data[0].in);


    for(var i=0; i < data.length; i++){

        if((data[i].in) > high){
            high = (data[i].in);
        }

        if((data[i].out) > high){
            high = (data[i].out);
        }

    }

    return high;

}